import { ContactBalanceQueryProps } from '@features/contactBalance'

import { QueryKeys } from '../../../enums/queryKeys'

export const getDebtorsQueryKey = (queryProps: ContactBalanceQueryProps): [QueryKeys, ContactBalanceQueryProps] => [
  QueryKeys.Debtors,
  queryProps,
]
